import type { NavigateFunction } from "react-router-dom"

export const PATH_INFO = {
  LOGIN: {
    PATH: "",
  },
  COMPANY_LIST: {
    PATH: "/company/list",
  },
  COMPANY_MANAGE: {
    PATH: "/company/:companyId/manage",
  },
  COMPANY_INFO: {
    PATH: "/company/:companyId/info",
  },
  COMPANY_DEVICES_LIST: {
    PATH: "/company/:companyId/device-list",
  },
  COMPANY_DEVICE_MANAGE: {
    PATH: "/company/:companyId/device-manage/:deviceId",
  },
  COMPANY_MEASUREMENTS_LIST: {
    PATH: "/company/:companyId/measurements-list",
  },
  DEPARTMENT_LIST: {
    PATH: "/company/:companyId/department-list",
  },
  DEPARTMENT_MANEGE: {
    PATH: "/company/:companyId/department-manage/:departmentId",
  },
  DEPARTMENT_DETAIL: {
    PATH: "/company/:companyId/department-detail/:departmentId",
  },
  DEPARTMENT_USER_DETAIL: {
    PATH: "/company/:companyId/department-user-detail/:departmentId/:userId",
  },
  DEPARTMENT_USER_MANAGE: {
    PATH: '/company/:companyId/department-user-manage/:departmentId/:userId'
  },
  DEVICE_LIST: {
    PATH: "/device/list",
  },
  DEVICE_MANAGE: {
    PATH: "/device/:deviceId/manage",
  },
  MEASUREMENTS_ERROR: {
    PATH: '/company/:companyId/measurements-error-settings'
  },
  NAME_MATCHING: {
    PATH: '/name-matching/manage'
  }
};

const ordinalRules = new Intl.PluralRules('en-US', { type: 'ordinal' })
const ordinalSuffixMap: Record<Intl.LDMLPluralRule, string> = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
  many: 'th',
  zero: 'th'
}

export function formatOrdinal(num: number) {
  const rule = ordinalRules.select(num)
  const suffix = ordinalSuffixMap[rule] ?? ordinalSuffixMap.other
  return `${num}${suffix}`
}

export function getAuthHeaders(
  navigate: NavigateFunction,
  extraHeaders: Record<string, string> = {}
) {
  const token = sessionStorage.getItem("token")
  if (!token) {
    sessionStorage.removeItem("token")
    navigate(PATH_INFO.LOGIN.PATH)
    return null
  }

  return {
    ...extraHeaders,
    Authorization: `Bearer ${token}`,
  }
}

export const MEASUREMENT_LIST = [
  "AH(直線)",
  "ウエスト",
  "カフス幅",
  "ヒップ",
  "リブ(袖口)",
  "リブ幅(裾)",
  "リブ幅(袖口)",
  "リブ幅(袖口)(右)",
  "リブ幅(袖口)(左)",
  "わたり幅",
  "衿幅",
  "襟幅",
  "肩幅",
  "股下",
  "身幅",
  "裾幅",
  "裾幅(右)",
  "裾幅(左)",
  "前下がり",
  "前股ぐり",
  "前股上",
  "総丈",
  "袖巾",
  "袖口幅(右)",
  "袖口幅(左)",
  "袖丈",
  "袖丈(右)",
  "袖丈(左)",
  "袖幅",
  "着丈(CB)",
  "着丈(NP)",
  "天幅",
  "膝幅",
  "裄丈",
  "裄丈(右)",
  "裄丈(左)",
  "ボタン間隔",
]